/**
 * 权限组编辑页面
 * 创建时间：2017-03-23
 * 创建人：masonchen
 */
<template>
	<div class="wrapper wrapper-content h100pp" v-loading="loadingstatus" element-loading-text="加载中">
	    <div class="float-e-margins ibox-content animated fadeInRight h100pp">
	    	<div class="row">
	    		<div class="form-horizontal">
					<label class="col-sm-1 control-label text-left">权限组所属企业</label>
					<div class="col-sm-2">
					<!--	<input v-if="mode===1" type="text" readonly v-model.trim="content.customerName" class="form-control"/>-->
						<input id="auth_custome" type="text" 
							class="form-control" v-model.trim="content.customerName"
							:readonly="mode!==1 || mode===1">
						<!--<input id="auth_custome" @click="showMenu" type="text" 
							class="form-control" v-model.trim="content.customerName"
							:readonly="mode!==1 || mode===1">-->
					</div>
					<div id="menuContent" class="menuContent" style="display:none; position: absolute;">
						<ul id="orgTree" class="ztree ztree-slide" style="margin-top:0; width:250px; height: 300px;"></ul>
					</div>
		    		<div class="col-sm-5">
			    		<label v-if="mode !== 1 && content.userList" class="control-label">当前权限组已应用于了 {{content.userList}}。</label>
			    		<!--<label class="control-label">当前权限组已应用于了 {{content.userList}}。</label>-->
		    		</div>
		    		<!--<div class="col-sm-4 text-right">
		    			<button type="button" v-if="permission.indexOf('authorityList_open') == -1" @click="operator()" class="btn btn-primary">打开操作员管理功能</button>
		    		</div>-->
				</div>
	    	</div>
	    	<div class="hr-line-dashed"></div>
			<div class="row h100pp"style="overflow: auto; height: calc(100% - 70px);">
				<div class="form-horizontal h100pp">
					<div class="col-sm-3 gray_right02 h100pp">
						<div class="row" >
							<label class="control-label pl5px" style="color: red;">*功能权限</label>
						</div>
						<div v-if="mode !== 3" class="pl50px pb10px checkbox checkbox-success checkbox-inline">
							<input class="" id="selectCheckAllFunc" type="checkbox" v-model="isCheckAllFunc" :disabled="mode == '3'">
							<label for="selectCheckAllFunc">所有功能</label>
							<br />
						</div>
						<div class="ibox-content" style="height:calc(100%-25px); overflow: auto;">
					        <ul :id="funcTreeId" class="ztree"></ul>
					    </div>			
					</div>
					<div class="col-sm-3 gray_left02 gray_right02 h100pp">
						<div class="row">
							<label class="control-label pl5px" style="color: red;">
								车辆监控权限
								<!--<span v-if="picked=='1'">（已选所有分支）</span>
								<span v-if="picked=='0'">（已选 {{carlistCount}} 个分支）</span>-->
							</label>
						</div>
						<div class="pl50px pt10px">
							<br />
							<radio v-model="picked" true-value="1" :disabled="mode == '3'">所有分支</radio>
							<br /><br />
							<radio v-model="picked" true-value="0" :disabled="mode == '3'">指定车辆分支</radio>
							<br /><br />
						</div>
						<div class="ibox-content" v-show="picked=='0'" style="height:calc(100%-25px); overflow: auto;">
					        <ul :id="carTreeId" class="ztree"></ul>
					    </div>
					</div>
					<div class="col-sm-6 gray_left02 h100pp">
						<form class="form-horizontal">
							<div class="form-group">
								<label class="col-sm-2 control-label text-left red">*权限组名称</label>
								<div class="col-sm-4" v-bind:class="{ 'form-group--error': $v.content.roleName.$error}">
									<input type="text" class="form-control" v-model.trim="content.roleName" @input="$v.content.roleName.$touch()" :readonly="mode == '3'" maxlength="30">
									<span class="form-group__message cus_message" v-if="!$v.content.roleName.required && $v.content.roleName.$error">权限组名称为必填项</span>
								</div>
								<label class="col-sm-2 control-label text-right red">*权限组状态</label>
								<div class="col-sm-4">
									<select class="form-control" v-model.trim="content.isEnable" :readonly="mode == '3'">
										<option v-for="(item, index) in orgStatusInfo" v-bind:value="item.value">{{ item.name }}</option>
									</select>
								</div>
							</div>
							<div class="form-group">
								<label class="col-sm-2 text-right control-label">备注</label>
								<div class="col-sm-10" v-bind:class="{'form-group--error': $v.content.remark.$error}">
									<textarea class="form-control" rows="4" v-model.trim="content.remark" @input="$v.content.remark.$touch()" :readonly="mode == '3'"></textarea>
									<span class="form-group__message cus_message" v-if="!$v.content.remark.maxLength">备注不得超过300字</span>
								</div>
							</div>
							
							<br />
							<div class="form-group">
								<label class="col-sm-2 control-label text-left">创建人</label>
								<div class="col-sm-4">
									<input type="text" class="form-control" v-model.trim="content.createrName" readonly>
								</div>
								<label class="col-sm-2 control-label text-right">创建时间</label>
								<div class="col-sm-4">
									<input class="form-control" v-model="content.createDate" readonly>
								</div>
							</div>
							<br />	
							<div class="form-group">
								<label class="col-sm-2 control-label text-left">修改人</label>
								<div class="col-sm-4">
									<input type="text" class="form-control" v-model="content.updateName" readonly>
								</div>

								<label class="col-sm-2 control-label text-right">修改时间</label>
								<div class="col-sm-4">
									<input class="form-control" v-model="content.updateDate" readonly>
								</div>
							</div>
							<br /><br />
							<div class="col-sm-12 text-right" v-if="mode !== 3">
								<button type="button" class="btn btn-primary white" :disabled="!enableSubmit" @click="saveAuthGroup()">保存</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
		<sub-modal ref="modal1" size="small" title="提示">
			{{messageStr}}
			<div slot="footer">
		            <!--<button class="btn btn-primary">Say Hi</button>-->
		            <button @click="confirm" class="btn btn-primary">确定</button>
		    </div>
		</sub-modal>
		
		<!--   弹出框子组件2        -->
		<sub-modal ref="modal2" size="small" title="提示">
			确定删除 操作员？
			<div slot="footer">
		            <!--<button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="remove" class="btn btn-primary">确定</button>-->
		    </div>
		</sub-modal>
	</div>
</template>

<script>
	// ztree 相关
	import 'assets/plugins/ztree/css/metroStyle/metroStyle.css'
	import 'assets/plugins/ztree/js/jquery.ztree.core.js'
	import 'assets/plugins/ztree/js/jquery.ztree.excheck.js'
	import 'assets/plugins/ztree/js/jquery.ztree.exedit.js'
	// vuelidate校验
	import { required, maxLength } from 'vuelidate/lib/validators'
	import Radio from 'components/common/Radio' 
	import SubModal from 'components/common/SubModal'
	import { OPERATE_SUCCESS, OPERATE_EXCEPTION } from 'static/message'
	import {INFO_STATUS} from 'static/constant'
	export default{
		name: "PageAuthrityEdit",
		components: {
			SubModal,
			Radio
		},
		data() {
			return{
				permission:this.$store.state.permission.permission["authorityList"]?this.$store.state.permission.permission["authorityList"]:[],
				loadingstatus:false,
				orgStatusInfo:INFO_STATUS,
				picked: '1',				// 1：所有车辆分支 2：指定车辆分支
//				funcCount: 1,				//已勾选功能的计数器
				carlistCount: 0,			//已勾选的车辆分组的计数器
				isCheckAllFunc: false,		//功能树是否选择全部功能
				auth_com_name:'',			//权限组所属企业名称
				auth_com_tree:[],			//权限组所属企业树
				// 功能树选项对象
				funcSetting: {
					data: {
		                simpleData: {
		                    enable: true
		                },
		                key:{
		                	url:'_url'
		                }
		           	},
		           	check: {
		           		enable: true,
		           		chkboxType : { "Y" : "ps", "N" : "ps" }
		           	},
		           	callback: {
		           		onCheck: null
		           	}
				},
				// 功能树选项对象
				carSetting: {
					data: {
		                simpleData: {
		                    enable: true
		                },
		                key:{
		                	url:'_url'
		                }
		           	},
		           	check: {
		           		enable: true,
		           		chkboxType : { "Y" : "", "N" : "" }
		           	},
		           	callback: {
		           		onCheck: null
		           	}
				},
				content: {
					
				},
				defaultContent: {				// 新建时默认的权限组内容
					id: "",
					roleCode: "",
					roleName: "",
					userList: "",
					resourceCount: "",
					resourceList: "",
					resourceAll: "",
					groupAll: "",
					groupList: "",
					isEnable: "1",
					orderno: "",
					remark: "",
					customerId: 3234837,
					customerName: "",
					createDate: "",
					createrId: "",
					createrName: "",
					updateDate: "",
					updateId: "",
					updateName: ""
				},
				functionTree:[],									// 功能树
				carlistTree:[],										// 车辆分组树
				orgTree:[],											// 组织机构树
				funcTreeId: Math.random().toString().substring(2,6),// 功能树DOM 的id
				carTreeId: Math.random().toString().substring(2,6),	// 车辆分组树DOM 的 id
				messageStr: ""										// 弹出框提示内容
			}
		},
		computed: {
			enableSubmit: function(){								// 可以提交的
				this.content.roleName;
				this.content.remark;
				return this.$v.content.roleName.required && this.$v.content.remark.maxLength;
			}
		},
		validations: {
			content: {
				roleName: {
					required
				},
				remark: {
					maxLength: maxLength(300)
				}
			}
		},
		watch: {
			// 根据模式重设参数
			mode: function(val){					//"1"：新建模式		“2”：编辑模式		“3”：查看模式 （不可编辑）
				this.$v.content.roleName.$reset();
				const { mode, content, data } = this;
				if(mode !== 1){		//查看、编辑
					this.content = Object.assign({}, data);
					this.getTreeData(1);
				} else {			//新建
					this.functionTree.forEach(node => {
						node.isCheck = false;
					})
					this.carlistTree.forEach(node => {
						node.isCheck = false;
					})
					this.content = Object.assign({}, this.defaultContent);
			//		this.getTreeData(0);
					
				}
			},
			picked: function(val){
				if(val === 1){
					this.initCarTree();
				}
			},
			// 点击功能权限的所有功能
			isCheckAllFunc: function(val){
				if(val){
					this.functionTree.forEach( node => {
						node.checked = true;
					});
				}
				else {
					this.functionTree.forEach( node => {
						if (node.id!="1"){
							node.checked = false;
						}
					});
				}
				this.initFuncTree();
			},
			isShow: function(val){
				// 当此页面可见时，在新建状态下，重置数据
				if(val && this.mode === 1){
					this.content = this.deepcopy(this.defaultContent);
					this.picked = '1';
					this.isCheckAllFunc = false;
				//	this.getTreeData(0);
					this.content.customerName = this.auth_com_name;
					this.getOrgTreeData();
					this.$v.content.$reset();
				}
				if(val && this.mode !== 1){
					this.content = Object.assign({}, this.data);
					this.getTreeData(1);
					this.picked = this.data.groupAll;
					if(this.data.resourceAll === 1){
						// 所有功能
						this.isCheckAllFunc = true;
					} else {
						this.isCheckAllFunc = false;
					}
				}
				if(!val){//!val&&this.functionTree=this.carlistTree=this.orgTree=[]
					this.functionTree = [];									// 功能树
					this.carlistTree = [];										// 车辆分组树
					this.orgTree = [];
				}
			}
		},
		props: {
			mode: {
				default: 0,			//"1"：新建模式		“2”：编辑模式		“3”：查看模式 （不可编辑）
				type: Number
			},
			data: {
				default: function(){
					return {
						id: "",
						roleCode: "",
						roleName: "",
						userList: "",
						resourceCount: "",
						resourceList: "",
						resourceAll: "",
						groupAll: "",
						groupList: "",
						isEnable: "1",
						orderno: "",
						remark: "",
						customerId: 3234837,
						customerName: "",
						createDate: "",
						createrId: "",
						createrName: "",
						updateDate: "",
						updateId: "",
						updateName: ""
					}
				},
				type: Object
			},
			// 是否显示当前页面，用于点击新建时清空数据
			isShow: {
				default: false,
				type: Boolean
			}
		},
		beforeMount(){
			if(this.mode === 1){	// 新建
				this.content = this.deepcopy(this.defaultContent);
			//	this.getTreeData(0);
				//  当处于新建状态且 TODO: 当前用户为超级管理员时
				this.getOrgTreeData();
			}
		},
		mounted(){
			const { initFuncTree, initCarTree, initOrgTree } = this;
			initFuncTree();
			// initOrgTree();
		},
		methods:{
			// 初始化树
			initFuncTree(){
				const { funcSetting, functionTree, carlistTree, funcCallback, countCarlist, funcTreeId, beforeCheck } = this;
				funcSetting.callback.onCheck = funcCallback;
				funcSetting.callback.beforeCheck = beforeCheck;
				$.fn.zTree.init($("#" + funcTreeId), funcSetting, functionTree);
				this.funcTree = $.fn.zTree.getZTreeObj(funcTreeId);
//				this.countFunc();
				this.setNoCheckNodes();
			},
			initCarTree(){
				const { carSetting, functionTree, carlistTree, countCarlist, carTreeId } = this;
//				if(this.carTree) return;
				// 车辆分组树选项对象
				var carlistSetting = Object.create(carSetting);
				carlistSetting.callback.onCheck = countCarlist;
				$.fn.zTree.init($("#" + carTreeId), carlistSetting, carlistTree);
				this.carTree = $.fn.zTree.getZTreeObj(carTreeId);
				countCarlist();
			},
			//功能树回调
			funcCallback(event, treeId, treeNode){
//				this.countFunc();
				if(treeNode.isParent){
					let subNodes = this.funcTree.transformToArray(treeNode);
					subNodes.forEach( item => {
						if (treeNode.checked){
							this.funcTree.setChkDisabled(item, false);
							item.checked = true;
						}
					})
				}
				this.setNoCheckNodes();
			},
			// 统计已勾选的功能的数量
//			countFunc(){
//				this.funcCount = 1;
//				const { funcTree } = this;
//				var nodes = funcTree.getCheckedNodes(true);
//				nodes.forEach((node) => {
//					this.funcCount++;
//				})
//			},
			// 设置一些不可check的节点
			setNoCheckNodes(){
				let allNodes = this.funcTree.transformToArray(this.funcTree.getNodes());
				allNodes.forEach( treeNode => {
					if (treeNode.id == "70101" || treeNode.id == "70201"|| treeNode.id == "5010101"|| treeNode.id == "5010201"|| treeNode.id == "5010301"){
						let peerNodes=this.getPeerNodes(treeNode);
						if(peerNodes!=null){
							for(let z=0;z<peerNodes.length;z++){
								if(peerNodes[z].id!=treeNode.id){
									if (treeNode.checked){
										this.funcTree.setChkDisabled(peerNodes[z], false);
									}else{
										this.funcTree.setChkDisabled(peerNodes[z], true);
										peerNodes[z].checked = false;
										peerNodes[z].getParentNode().checked =false;
									}
									this.funcTree.updateNode(peerNodes[z]);
								}
							} 
						}
					}
				})
			},
			//获取兄弟节点
			getPeerNodes(targetNode){
				if(targetNode == null){  
		          return null;
		        }else{  
		            if(targetNode.getParentNode() != null){  
		                return targetNode.getParentNode().children;  
		            }  
		           return null;  
		        }  
			},
			// 统计已勾选的车队的数量
			countCarlist(){
				this.carlistCount = 0;
				const { carTree } = this;
				var nodes = carTree.getCheckedNodes(true);
				nodes.forEach((node,index) => {
					this.carlistCount++;
				})
			},
			// 查看状态不允许编辑
			beforeCheck(){//return this.mode!==3;
				if(this.mode === 3)
					return false;
				return true;
			},
			// 获取功能树和权限树的数据	
			// 参数treeType是新建或者编辑的flag，0：新建时初始化，有默认勾选 1：编辑时初始化，显示用户勾选数据
			getTreeData(treeType){
				const { content, initFuncTree, initCarTree, mode } = this;
				let param = {};
				param = {
						roleId: content.id,
						treeType: treeType,
						customerId: content.customerId
				}		
				this.$http.get(process.env.API_ROOT + "/account/roles/resource-group",{params:param})
				.then( res => {
					var resourceTree = res.data.data.resourceTree;
					var groupTree = res.data.data.groupTree;
				//	resourceTree[]
					const levv = this.$store.state.user.levv;

					resourceTree.map( node => {
						node.isParent = false;
						node.open = false;
						if (node.id=="1"){
							node.chkDisabled = true;
						}
						// if(node.name=='综合监控平台'){
						// 	node.name = '救援监控平台'
						// }else if(node.name=='车辆轨迹回放'){
						// 	node.name = '救援车辆轨迹'
						// }else if(node.name == '车辆档案管理'){
						// 	node.name = '救援车辆一览'
						// }else{
						// 	node.name = node.name
						// }
						return node;
					});
					this.functionTree = resourceTree;
					this.carlistTree = groupTree;
					initFuncTree();
					initCarTree();
				}, res => {
					// alert(res.data.message);
				});
			},
			// 编辑权限组
			saveAuthGroup(){
				if(this.mode == 1) {
					this.createAuthGroup();
					return;
				}
				this.loadingstatus = true;
				var contentTmp = this.deepcopy(this.content); //let
				const { getCheckRootNodes, getFuncSelectedLeafNodes, deepcopy, getCarAllNodes} = this;
				var tmp1 = (getFuncSelectedLeafNodes()); 	// resource  let
				contentTmp.resourceList = tmp1.join(',');
				if(this.picked == '1'){ // 选择所有分支
					contentTmp.groupAll = '1';
					contentTmp.groupList = getCarAllNodes().join(',');
				} else {
					contentTmp.groupAll = '0';
					var tmp2 = (getCheckRootNodes());		// group
					contentTmp.groupList = JSON.stringify(tmp2);
				}
				if(this.isCheckAllFunc){
					contentTmp.resourceAll = '1';
				} else {
					contentTmp.resourceAll = '0';
				}
				delete contentTmp.updateDate;
				
				this.$http.put(process.env.API_ROOT + "/account/roles", contentTmp)
				.then( res => {
					if(res.data.success){
						this.openModal1(OPERATE_SUCCESS);
						this.loadingstatus = false;
						return;
					}
					this.openModal1(res.data.message);
					this.loadingstatus = false;
				}, res => {
					this.openModal1(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			// 新建权限组
			createAuthGroup(){
				this.loadingstatus = true;
				const { getCheckRootNodes, getFuncSelectedLeafNodes, deepcopy, getCarAllNodes } = this;
				var contentTmp = deepcopy(this.content); //let
				contentTmp.groupList = JSON.stringify(getCheckRootNodes());
				contentTmp.resourceList = getFuncSelectedLeafNodes().join(',');
				if(this.picked == '1'){ // 选择所有分支
					contentTmp.groupAll = '1';
					contentTmp.groupList = getCarAllNodes().join(',');
				} else {
					contentTmp.groupAll = '0';
					var tmp2 = (getCheckRootNodes());		// group
					contentTmp.groupList = JSON.stringify(tmp2);
				}
				if(this.isCheckAllFunc){
					contentTmp.resourceAll = '1';
				} else {
					contentTmp.resourceAll = '0';
				}
				this.$http.post(process.env.API_ROOT + "/account/roles", contentTmp)
				.then( res => {
					if(res.data.success){
						this.openModal1(OPERATE_SUCCESS);
						this.loadingstatus = false;
						return;
					}
					this.openModal1(res.data.message);
					this.loadingstatus = false;
				}, res => {
					
					this.openModal1(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.openModal1(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})
			},
			// 获取funcTree被选中的叶子节点
			getFuncSelectedLeafNodes(){
				var result = [];
				const { funcTree } = this;
				var nodes = funcTree.getCheckedNodes(true);
				nodes.forEach( node => {
					result.push(node.id);
				})
				result.push(1);
				return result;
			},
			// 获取carTree被选中的叶子节点
			getCarSelectedLeafNodes(){
				var result = [];
				const { carTree } = this;
				var nodes = carTree.getCheckedNodes(true);
				nodes.forEach( node => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          
					result.push(node.id);
				})
				return result;
			},
			// 若所有的子节点已勾选，则只选择当前节点
			getCheckRootNodes(){
				let queue = [];
				let result = [];
				let tree = this.carTree.getNodes();
				queue.push(...tree);
				while(queue.length != 0){
					let node = queue.shift();
					let checkState = node.getCheckStatus();
					// 若全勾选，则加到result
					if(checkState.checked && !checkState.half){
						result.push({
							groupId: node.id,
							noFilterStatus: "1"
						})
					} else if (checkState.checked && checkState.half){
						// 否则，若半勾选，则加到result并把childNode加到队列中
						result.push({
							groupId: node.id,
							noFilterStatus: "0"
						})
						if(node.children){
							queue.push(...node.children);
						}
					} else if (!checkState.checked){
						// 若未勾选，则把子节点加到队列中
						if(node.children){
							queue.push(...node.children);
						}
					}
				}
				console.log(result);
				return result;
			},
			// 选择所有分支时， 获取所有车辆分支
			getCarAllNodes(){
				var result = [];
				const { carTree } = this;
				var nodes = carTree.getNodes();
				nodes.forEach( node => {
					if(!node.isParent){
						result.push(node.id);
					}
				})
				return result;
			},
			// 深复制
			deepcopy(source) { 
				var result={};
				for (var key in source) {
			      result[key] = typeof source[key]==='object'? this.deepcopy(source[key]): source[key];
				} 
			   	return result; 
			},
			// 以下函数为组织机构下拉树相关 ====================================
			// 初始化组织机构树
			initOrgTree(){
				var setting = {
					check: {
						enable: true,
						chkStyle: "radio",
						radioType: "all"
					},
					view: {
						dblClickExpand: false
					},
					data: {
						simpleData: {
							enable: true
						}
					},
					callback: {
						onClick: this.onClick,
						onCheck: this.onCheck
					}
				};
				$.fn.zTree.init($(".ztree-slide"), setting, this.orgTree);
			},
			// 获取组织机构树
			getOrgTreeData(){

				this.$http.get(process.env.API_ROOT + '/account/customer-tree')
				.then( res => {
					if(!res.data.success){
						// alert(res.data.message);
						return;
					}
					var orgTreeTmp = res.data.data;
					this.auth_com_tree = orgTreeTmp;
					if(this.mode===1){
						this.auth_com_name = orgTreeTmp[0].name
					}
					orgTreeTmp.map( item => {
						item.open = true;
						return item;
					});
					orgTreeTmp[0].checked = true;
					this.orgTree = orgTreeTmp;
					this.initOrgTree();
					
					//修复组织树渲染完毕 而功能树未出现的bug 2017-5-16
					let treeNode = orgTreeTmp[0];
					this.content.customerId = treeNode.id;
					this.content.customerName= treeNode.name;
					treeNode.checked =true;
					this.getTreeData(0);
					this.isCheckAllFunc = false;
				}, res => {
					// alert(res.data.message);
				});
			},
			showMenu() {
				if(this.mode !== 1) return;
				var cityObj = $("#auth_custome");
				var cityOffset = $("#auth_custome").offset();
				$(".menuContent").css({ left:"9%", top:"40px",zIndex:'999' }).slideDown("fast");

				$("body").bind("mousedown", this.onBodyDown);
			},
			onClick(e, treeId, treeNode) {
				var zTree = $.fn.zTree.getZTreeObj("orgTree");
				zTree.checkNode(treeNode, !treeNode.checked, null, true);
				return false;
			},
			onCheck(e, treeId, treeNode) {
				if(!treeNode.checked) return ;
				this.content.customerId = treeNode.id;
				this.content.customerName= treeNode.name;
				// 刷新树
				this.getTreeData(0);
				this.isCheckAllFunc = false;
			},
			onBodyDown(event) {
				if (!(event.target.id == "auth_custome" || event.target.id == "menuContent" || $(event.target).parents(".menuContent").length>0)) {
					this.hideMenu();
				}
			},
			hideMenu() {
				$(".menuContent").fadeOut("fast");
				$("body").unbind("mousedown", this.onBodyDown);
			},
			
			// 消息弹出框相关 ==============================
			openModal(ref) {
            	this.$refs[ref].open();
        	},
        	closeModal(ref){
        		this.$refs[ref].close();
        	},
        	openModal1(message){
        		this.messageStr = message;
        		this.openModal("modal1")
        	},
        	confirm(){
        		this.closeModal("modal1");
        		// 通知父组件刷新数据
				this.$emit("callback", "new-success");
        	}
		}
	}
</script>

<style>
.ztree-slide {
    margin-top: 10px;
    border: 1px solid #617775;
    background: #ffffff;
    width: 220px;
    height: 500px;
    overflow-y: scroll;
    overflow-x: auto;
}
</style>


// WEBPACK FOOTER //
// PageAuthorityEdit.vue?38f5f0bc